<template>
    <x-dialog
        v-model="isOpen"
        :width="width"
        :max-width="maxWidth"
        persistent
        :content-class="contentClass"
    >
        <x-card light>
            <x-btn color="" elevation="2" icon outlined class="close-icon" @click="isOpen = false">
                <x-icon :size="28">close</x-icon>
            </x-btn>

            <x-card-title primary-title data-test="modal-title">{{ computedTitle }}</x-card-title>

            <x-card-text data-test="modal-text"><slot /></x-card-text>

            <x-card-actions>
                <template v-if="confirmation">
                    <x-btn color="cancel" @click="resolveAndClose(false)" data-test="modal-cancel-button">{{ cancelText }}</x-btn>

                    <x-btn color="secondary" :disabled="actionDisabled" @click="resolveAndClose(true)" data-test="modal-action-button">{{ computedActionText }}</x-btn>
                </template>

                <template v-else>
                    <x-btn color="secondary" :disabled="actionDisabled" @click="resolveAndClose" data-test="modal-action-button">{{ computedActionText }}</x-btn>
                </template>
            </x-card-actions>
        </x-card>
    </x-dialog>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            title: {
                type: String
            },
            maxWidth: {
                type: [String, Number],
                default: 800
            },
            width: {
                type: [String, Number],
                default: 800
            },
            confirmation: {
                type: Boolean,
                default: false
            },
            actionText: {
                type: String
            },
            actionDisabled: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'Cancel'
            },
            contentClass: {
                type: String,
                default: 'dialog-modal'
            },
        },
        data() {
            return {
                isOpen: false,
                resolve: false
            }
        },
        computed: {
            computedTitle() {
                return this.title || (this.confirmation ? 'Are you sure?' : 'Alert');
            },
            computedActionText() {
                return this.actionText || (this.confirmation ? 'Yes' : 'OK');
            }
        },
        methods: {
            open() {
                this.isOpen = true;

                return new Promise((resolve) => {
                    this.resolve = resolve
                });
            },
            resolveAndClose(confirmed) {
                if (this.resolve) {
                    this.resolve(confirmed);
                    this.resolve = false;
                }

                this.isOpen = false
            }
        }
    }
</script>
<style lang="scss" scoped>
.close-icon {
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 15px;
    color: black !important;
    background-color: white !important;
    border: 1px solid black !important;
    &:hover {
        color: white !important;
        background-color: black !important;
    }
}
</style>
